import Template from './template';
import MasterData from './config/master-data';

let Nodes;

Template.add('catalog-product',
    `<div class="item-picker__item btn js--trigger-open-inventory" data-inventory-id="catalog-page-{{productId}}">
        <img class="item-picker__img" src="{{imgInventory}}" draggable="false">
        <div class="item-picker__label">{{name}}</div>
    </div>`);

Template.add('catalog-page',
    `<div class="inventory inventory_overlay" data-inventory-id="catalog-page-{{productId}}">
        <div class="tabs">
            <div class="tabs__tab tabs__tab_external tabs__tab_icon js--disabled lnr lnr-cross js--trigger-close-inventory"></div>
        </div>
        <div class="inventory__content inventory__content_scrollable">
            <div class="inventory__text">
                <img class="item-picker__img" src="{{imgInventory}}" draggable="false">
                <h2 class="lt--text-center lt--margin-top_big">{{name}}</h2>
                <p>{{description}}</p>
            </div>
        </div>
    </div>
    `);


$(() => {
    Nodes = getNodes();
    MasterData.promise.then(renderCatalog);
});

function getNodes() {
    return {
        tabs: $('#catalog-tabs'),
        items: $('#catalog-items'),
        pages: $('#catalog-pages')
    }
}

function renderCatalog() {
    MasterData.categoryKeysOrdered.forEach((catId) => {
        const catName = MasterData.categories[catId].name,
            products = MasterData.productsByCategory[catId],
            catalogCatId = 'c-' + catId;

        if (!products) return;

        // render category tab
        Nodes.tabs.append(Template.fill('inventory-tab', {
            categoryId: catalogCatId,
            title: catName,
            label: catName.substr(0, 2)  // Template.fill('lnr-icon', {icon: MasterData.iconMappings[catId] || MasterData.iconMappings.default})
        }));

        // render category product html
        let htmlProducts = products.reduce((html, prod) => {
            let nameParts = prod.name.split('-'),
                name = nameParts[0].trim(),
                description = nameParts.length > 1 ? nameParts[1].trim() : '',
                label = `${name}<small>${description}</small>`;

            return html + Template.fill('catalog-product', {
                imgInventory: prod.img.inventory,
                name: label,
                productId: prod.id
            })
        }, '');

        Nodes.items.append(Template.fill('inventory-category', {
            id: catalogCatId,
            name: catName,
            items: htmlProducts
        }));
    });

    Nodes.pages.append(MasterData.products.reduce((html, prod) => {
        return html + Template.fill('catalog-page', {
            productId: prod.id,
            name: prod.name,
            imgInventory: prod.img.inventory,
            descriptionShort: prod.descriptionShort,
            description: prod.description
        });
    }, ''));
}

export default {}